const SUPPORTED_LOCALES: Locale[] = ['da', 'en', 'nb', 'sv'];

export const FALLBACK_LOCALE = SUPPORTED_LOCALES[0];

export const isLocale = (locale?: string): locale is Locale => {
  return SUPPORTED_LOCALES.includes((locale as Locale) ?? '');
};

const getLocale = (locale?: string): Locale => {
  if (locale && isLocale(locale)) {
    return locale;
  }

  if (isLocale(process.env.NEXT_PUBLIC_DEFAULT_LOCALE)) {
    return process.env.NEXT_PUBLIC_DEFAULT_LOCALE;
  }

  return FALLBACK_LOCALE;
};

export default getLocale;
